var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCodiconRunAbove(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.655 1.51562L1.5 2.13063V20.1306L2.67 20.7606L16.17 11.7606V10.5156L2.655 1.51562ZM3 18.7356V3.54063L14.4 11.1456L3 18.7356ZM18.225 12.0006H19.29L23.04 15.7506L21.975 16.8156L19.5 14.3406V22.5006H18V14.3256L15.525 16.8006L14.475 15.7506L18.225 12.0006Z",
    fill: "#14B8A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodiconRunAbove);
export default __webpack_public_path__ + "static/media/codicon_run-above.7a8111ee867bc22b883906e2b8e794a2.svg";
export { ForwardRef as ReactComponent };